/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Mirrors the API access token into a cookie so Unity WebGL asset fetches can authenticate.
 *
 * Unity's request layer cannot attach an `Authorization` header, so the same-origin 3D asset
 * proxy (`/api/v1/assets/3d/**`) reads the JWT from this cookie instead. The name must match the
 * backend's `vaas.assetproxy.cookieName`. Scoped to `/api` so it is only sent on backend calls
 * (never on static-asset requests); `SameSite=Lax` is sufficient because the fetches are
 * same-origin. `Secure` is added on HTTPS.
 */
const COOKIE_NAME = 'access_token';

export function mirrorAccessTokenToCookie(token: string | null | undefined): void {
  /* v8 ignore next -- defensive: document is always present in the browser runtime. */
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  if (!token) {
    // Signed out or token acquisition failed: expire any prior cookie so the backend cannot keep
    // authenticating Unity fetches with a stale token.
    document.cookie = `${COOKIE_NAME}=; path=/api; Max-Age=0; SameSite=Lax${secure}`;
    return;
  }
  document.cookie = `${COOKIE_NAME}=${token}; path=/api; SameSite=Lax${secure}`;
}
